<template lang="pug">
	#sfc-main-container
		no-ssr
		.header-background(v-if="isWhiteLabel")
			.header
				.logo
					img(:src="`${$store.state.config.s3ResourceHost}/images/logo-prudential.png`" alt="Prudential Logo")
		#sfc-main-content
			.header(v-if="!isWhiteLabel")
				.logo
					img(:src="`${$store.state.config.s3ResourceHost}${logoUrl}`")
				.back-button(v-if="showBackButton")
					sfc-button(text="BACK" :blue="true" :back-arrow="true" @click="back")
			.content
				nuxt
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#sfc-main-container
		.header-background
			background-color: #07639D
			.header
				width: 1140px
				margin: auto
				display: flex
				justify-content: space-between
				align-items: center
				padding: 10px 0
				@media(max-width: 1199px)
					width: 960px
				@media(max-width: 991px)
					width: 720px
				@media(max-width: 767px)
					width: 540px
				@media(max-width: 575px)
					width: 95%
				.logo
					img
						max-width 180px

	#sfc-main-content
		width: 1140px
		margin: auto
		background-color: #fff !important
		@media(max-width: 1199px)
			width: 960px

		@media(max-width: 991px)
			width: 720px

		@media(max-width: 767px)
			width: 540px

		@media(max-width: 575px)
			width: 95%

		.header
			margin-top: 10px
			display: flex
			justify-content: space-between
			align-items: center
			border-bottom: 1px solid sfc-pale-gray
			padding-bottom: 10px

		.content
			padding-top: 30px

		.logo
			img
				max-width 180px

</style>



<script>
import SfcButton from '@/common/components/sfc-button'


export default {
	components: {
		SfcButton
	},
	data(){
		return {
			indexPages: [
				{url: '/prudential', logoUrl: '/images/logo-on-white.svg'}
			]
		}
	},
	computed: {
		showBackButton(){
			let indexPagesUrls = this.indexPages.map( page => page.url)
			return indexPagesUrls.indexOf(this.$route.path) == -1
		},
		logoUrl(){
			for(let entry of this.indexPages){
				if(this.$route.path.indexOf(entry.url) == 0){
					return entry.logoUrl
				}
			}
		},
		isWhiteLabel(){
			return this.$route.path == "/prudential/cost-calculator"
		}
	},
	methods: {
		back(){
			if(this.$route.path.indexOf("/compare-savings-options") >= 0){
				history.back()
				return
			}
			for(let entry of this.indexPages){
				if(this.$route.path.indexOf(entry.url) == 0){
					this.$router.push(entry.url)
					return
				}
			}
		}
	}
}
</script>
